import { Builder, Image as BuilderImage } from "@builder.io/react";
import CustomButton from "components/CustomButton";
import { SIGNUP_LINK } from "components/constants";
import { StaticImage } from "gatsby-plugin-image";
import { toMutable } from "types/common";
import * as styles from "./styles.module.scss";

const inputs = [
    {
        name: "suptitle",
        type: "text",
        defaultValue: "All Revenue Sources REAL-TIME",
    },
    {
        name: "title",
        type: "text",
        defaultValue: "Leave the data collection to us and focus on your next best move",
    },
    {
        name: "subtitle",
        type: "text",
        defaultValue:
            "Unparalleled solution to automate data collection, cleaning, consolidation and prediction for all sources and dimensions free you up to focus on your monetization strategies. Data-driven players are finally free to focus on monetization strategy an let data collection in real-time with us.",
    },
    {
        name: "buttonText",
        type: "text",
        defaultValue: "Try it Out, It's Free",
    },
    {
        name: "linkTo",
        type: "text",
        defaultValue: SIGNUP_LINK,
        required: true,
    },
    {
        name: "imageOrGif",
        type: "file",
        allowedFileTypes: ["jpg", "png", "jpeg", "gif", "svg"],
        required: true,
    },
    {
        name: "imageOrGifHover",
        type: "file",
        allowedFileTypes: ["jpg", "png", "jpeg", "gif", "svg"],
    },
    {
        name: "imageOrGifAlt",
        type: "text",
        defaultValue: "Gain Bidder Intelligence",
    },
] as const;

const AllRevenueSourceHero: BFC<typeof inputs> = ({
    suptitle,
    title,
    subtitle,
    buttonText,
    linkTo,
    imageOrGif,
    imageOrGifHover,
    imageOrGifAlt,
}) => {
    return (
        <div className="container">
            <div className={`${styles.firstGlow} gradient`}>
                <StaticImage src="./images/all-revenue-hero-first-glow.svg" alt="" />
            </div>
            <div className={`${styles.secondGlow} gradient`}>
                <StaticImage src="./images/all-revenue-hero-second-glow.svg" alt="" />
            </div>
            <div className={styles.wrapper}>
                <div className={styles.mainContent}>
                    <p className={styles.suptitle}>{suptitle}</p>
                    <h1 className={styles.title}>{title}</h1>
                    <p className={styles.subtitle}>{subtitle}</p>
                    <div className={styles.btn}>
                        <CustomButton to={linkTo}>{buttonText}</CustomButton>
                    </div>
                    <p className={styles.note}>No credit card required</p>
                </div>
                <div className={styles.image}>
                    {imageOrGifHover ? (
                        <img
                            onMouseOver={e => {
                                e.currentTarget.src = imageOrGifHover;
                            }}
                            onMouseOut={e => {
                                e.currentTarget.src = imageOrGif!;
                            }}
                            src={imageOrGif}
                            alt={imageOrGifAlt}
                            className={styles.image}
                        />
                    ) : (
                        //@ts-ignore
                        <BuilderImage altText={imageOrGifAlt} image={imageOrGif} />
                    )}
                </div>
            </div>
        </div>
    );
};

Builder.registerComponent(AllRevenueSourceHero, {
    name: "allRevenueSourceHero",
    inputs: toMutable(inputs),
});
